/**
 * @generated SignedSource<<4c294610fbf591217d6cad77d292c97d>>
 * @relayHash dedc8b21ca88936a360333a8d0f5599c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dedc8b21ca88936a360333a8d0f5599c

import { ConcreteRequest } from 'relay-runtime';
export type DocumentType = "AUDIO" | "PDF" | "PHOTO" | "VIDEO";
export type FileUploadSource = "DOC2_U" | "PATIENT" | "SOFIA";
export type FileUploadStatus = "ERROR" | "HYPERLINK_PROCESSING_FAILED" | "JAVA_SCRIPT_PROCESSING_FAILED" | "MALICIOUS" | "NO_THREAT_FOUND" | "SCAN_TIMEOUT" | "UPLOADED";
export type UploadDoc2USessionReportInput = {
  appointmentId: string;
  file: any;
};
export type useUploadDoc2UReportMutation$variables = {
  input: UploadDoc2USessionReportInput;
};
export type useUploadDoc2UReportMutation$data = {
  readonly uploadDoc2USessionReport: {
    readonly uploadAppointmentFilesOutput: {
      readonly attachments?: ReadonlyArray<{
        readonly attachmentType: DocumentType;
        readonly id: string;
        readonly thumbnailUrl: string | null;
        readonly uploadDate: string;
        readonly uploadSource: FileUploadSource;
        readonly uploadStatus: FileUploadStatus | null;
        readonly url: string;
      }>;
      readonly error?: {
        readonly fileName: string | null;
        readonly message: string;
      };
      readonly isSuccess?: boolean;
    } | null;
  };
};
export type useUploadDoc2UReportMutation = {
  response: useUploadDoc2UReportMutation$data;
  variables: useUploadDoc2UReportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSuccess",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AppointmentAttachment",
      "kind": "LinkedField",
      "name": "attachments",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thumbnailUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uploadDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "attachmentType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uploadSource",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uploadStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v2/*:: as any*/)
  ],
  "type": "SuccessUploadAppointmentFilesOutput",
  "abstractKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UploadAppointmentFilesError",
      "kind": "LinkedField",
      "name": "error",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fileName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ErrorUploadAppointmentFilesOutput",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUploadDoc2UReportMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UploadDoc2USessionReportPayload",
        "kind": "LinkedField",
        "name": "uploadDoc2USessionReport",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "uploadAppointmentFilesOutput",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useUploadDoc2UReportMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UploadDoc2USessionReportPayload",
        "kind": "LinkedField",
        "name": "uploadDoc2USessionReport",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "uploadAppointmentFilesOutput",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "dedc8b21ca88936a360333a8d0f5599c",
    "metadata": {},
    "name": "useUploadDoc2UReportMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "6aa71d35fba01350d2502e6b3770bde3";

export default node;
